import type { Translations } from './en.js';

const ptBR: Translations = {
  ok: 'OK',
  cancel: 'Cancelar',
  close: 'Fechar',
  confirm: 'Confirmar',
  language: 'Idioma',

  game_title: 'Aprimorar Espada',
  tap_to_start: 'Toque para iniciar',
  title_load_failed: 'Falha ao carregar imagem de título:',
  game_started: 'Aprimorar Espada iniciado!',

  level_label: 'Lv.{n}',
  gold_suffix: 'G',
  rate_suffix: '%',
  rate_clear: '🎉 Tudo concluído!',
  rate_display: '{rate}%',
  rate_display_boosted: '{rate}% ⬆',
  gold_display: '{amount} G',
  gold_display_free: '0 G (Grátis!)',

  btn_enhance: '⚒️ Aprimorar',
  btn_enhance_ready: '⚔️ Aprimorar',
  btn_enhance_complete: '🏆 Completo',
  btn_free_enhance: '▶ Aprimorar grátis',
  btn_exhausted: 'Esgotado',
  btn_boost: 'Taxa\nUP',
  btn_applying: 'Em\nuso!',
  btn_protection_active: '🛡️ Proteção ativa',
  btn_protection_use: '🛡️ Usar pergaminho',
  btn_sell: '💰 Vender',
  btn_sell_amount: '💰 {amount}G',
  btn_shop: '🏪 Loja',
  cost_max: 'MAX',
  cost_free: '0 G (Grátis!)',

  tab_settings: '⚙️ Ajustes',
  tab_inventory: '📦 Inventário',
  bgm_on: '🎵 Música ON',
  bgm_off: '🎵 Música OFF',
  sfx_on: '🔊 Sons ON',
  sfx_off: '🔊 Sons OFF',
  inventory_title: '⚔️ Armas guardadas',
  inventory_empty: 'Sem armas guardadas',
  equip: 'Equipar',
  equip_msg: '{name} equipada!',
  reset_confirm_title: '⚠️ Redefinir tudo?',
  reset_confirm_desc: 'Todo o progresso será apagado',
  reset: 'Redefinir',
  reset_start_over: '🔄 Recomeçar',
  menu_close: 'Fechar',

  inv_scrolls_title: '🛡️ Pergaminhos',
  inv_scrolls_line1: 'Básico: {c0}  |  Médio: {c1}',
  inv_scrolls_line2: 'Alto: {c2}  |  Ultra: {c3}',
  inv_weapon_entry: '{name} (Lv.{level})',

  ad_gold_title: 'Ver anúncio para aprimorar grátis',
  ad_gold_desc: 'Próximo aprimoramento custa 0 ouro',
  ad_gold_note: '(Pergaminhos e Taxa UP continuam ativos)',
  ad_gold_confirm: '▶ Assistir anúncio',
  ad_gold_free_next: 'Próximo aprimoramento grátis!',
  ad_gold_exhausted: 'Usos esgotados!',
  ad_gold_remaining: 'Restantes: {current}/3',

  boost_popup_title: '📺 Assistir anúncio',
  boost_confirm: '▶ Ver anúncio para aplicar',
  boost_close: 'Fechar',
  boost_applied: 'Taxa UP aplicada!',
  boost_already_applied: 'Já está ativo!',
  boost_exhausted: 'Usos esgotados!',
  boost_remaining: '🎬 Usos restantes: {current}/3',
  boost_popup_desc: 'Agora {rate}% → x{mult}',
  boost_rate_display: '{rate}%',
  boost_mult_2x: 'x2',
  boost_mult_1_5x: 'x1.5',
  boost_mult_1_3x: 'x1.3',

  protection_popup_title: '🛡️ Usar pergaminho',
  protection_use: 'Usar',
  protection_cancel: 'Cancelar',
  protection_popup_info:
    'Nível atual: Lv.{level}\nNecessário: {name} x1\nVocê tem: {count}',
  protection_activated: '{name} ativado!',
  protection_returned: '{name} devolvido',
  protection_protected: '🛡️ Protegido pelo pergaminho!',

  msg_max_level: 'Já está no nível máximo!',
  msg_gold_short: 'Ouro insuficiente!',
  msg_success_boost: 'Aprimoramento com boost!',
  msg_success: 'Aprimoramento sucedido!',
  msg_destroyed: '💥 DESTRUÍDA!',

  shop_title: 'Loja',
  tab_protection: 'Protecao',
  tab_weapons: 'Comprar armas',
  weapon_shop_title: '⚔️ Comprar armas',
  item_free: 'Grátis',
  close_shop: 'Fechar',
  buy_complete_title: 'Compra concluída!',
  buy_complete_desc: 'Os itens comprados estão em\nAjustes (topo) → 📦 Inventário.',
  buy_complete_ok: 'OK',
  scroll_shop_label: '{name} (Lv.{min}-{max})',
  scroll_purchased: '{name} obtido!',
  weapon_moved_to_inventory: '{name} → Inventário',
  price_display: '{amount}G',
  sell_received: '+{amount}G!',

  destroy_title: 'Arma destruída',
  destroy_ad_restore: '▶ Ver anúncio e restaurar',
  destroy_restore_ad: 'Ver anúncio e restaurar ({current}/{max})',
  destroy_give_up: 'Recomeçar',
  destroy_restore_count: '🎬 Restaurações: {current}/{max}',
  destroy_restored: 'Lv.{level} weapon restored!',
  ad_watch_fail: 'Falha ao reproduzir anúncio',
  weapon_restored: '{name} restaurada!',

  completion_title: 'Você completou a espada definitiva!',
  completion_all_done: '🏆 Todos os aprimoramentos concluídos! 🏆',
  congrats_text: '🎉 Parabéns! 🎉',
  register_name: '✏️ Registrar nome',
  prompt_register_name: 'Digite seu nome para o Hall da Fama:',
  no_completion: 'Ainda não há completadores',
  be_first: 'Seja o primeiro a terminar!',
  completion_close: 'Fechar',
  leaderboard_title: '📋 Hall da Fama',
  leaderboard_entry: '#{rank} - {name}',
  completion_rank_msg: 'Você é o completador #{rank}!',
  completion_total_msg: '{total} jogadores concluíram até agora',

  weapon_image_load_failed: 'Falha ao carregar imagem de arma:',

  weapon_0: 'Mãos nuas',
  weapon_1: 'Adaga comum',
  weapon_2: 'Espada de ferro',
  weapon_3: 'Espada de prata',
  weapon_4: 'Espada snowboard',
  weapon_5: 'Espada de onda',
  weapon_6: 'Espada garota mágica',
  weapon_7: 'Espada de urso',
  weapon_8: 'Espada crânio flamejante',
  weapon_9: 'Espada relâmpago',
  weapon_10: 'Adaga ao luar',
  weapon_11: 'Espada dragão',
  weapon_12: 'Espada musculosa',
  weapon_13: 'Espada rei diamante',
  weapon_14: 'Alabarda do dragão azul',
  weapon_15: 'Espada antiga',
  weapon_16: 'Espadas duplas do rei pirata',
  weapon_17: 'Espada grudenta de Dubai',
  weapon_18: 'Lâmina Sete-Sete',
  weapon_19: 'Cajado-espada mágico',
  weapon_20: 'Espada zumbidora',
  weapon_21: 'Espada paleta',
  weapon_22: 'Espada da natureza',
  weapon_23: 'Espada ciborgue',
  weapon_24: 'Espada buraco negro',
  weapon_25: 'Espada pássaro dourado',
  weapon_26: 'Espada cristal de poder',
  weapon_27: 'Espada dragão sombrio',
  weapon_28: 'Espada pinça',
  weapon_29: 'Espada IA',
  weapon_30: 'Espada motosserra',
  weapon_31: 'Espada estrela cadente',
  weapon_32: 'Espada sombria sombria',
  weapon_33: 'Espada galáctica',
  weapon_34: 'Espada de diamante caríssima',

  scroll_basic: 'Pergaminho básico',
  scroll_mid: 'Pergaminho médio',
  scroll_hi: 'Pergaminho alto',
  scroll_ultra: 'Pergaminho ultra',
  scroll_label_basic: 'Básico',
  scroll_label_mid: 'Médio',
  scroll_label_hi: 'Alto',
  scroll_label_ultra: 'Ultra',

  // === Materials (Sprint 1) ===
  mat_iron_dust: 'Pó de Ferro',
  mat_refining_core: 'Núcleo de Refinamento',
  mat_lava_essence: 'Essência de Lava',
  mat_abyss_crystal: 'Cristal do Abismo',

  mat_drop_notice: '+{amount} {name}',
  mat_drop_title: 'Material Obtido!',
  mat_double_ad: 'Assistir Anúncio x2',
  mat_doubled: 'x2 Aplicado!',
  mat_panel_title: 'Materiais',

  // === Keep / Weapon Inventory (Sprint 1) ===
  keep_btn: 'Guardar',
  keep_full: 'Armazenamento Cheio!',
  keep_lv1_blocked: 'Armas Lv.1 não podem ser armazenadas',
  keep_success: '{name} guardado!',
  keep_retrieve: 'Equipar',
  keep_sell: 'Vender',
  keep_slot_expand: 'Expandir Espaço',
  keep_slot_cost: '{amount}G',
  keep_slot_max: 'MAX',
  keep_slot_count: 'Espaços: {used}/{total}',
  keep_panel_title: 'Armas Guardadas',
  keep_empty: 'Nenhuma arma guardada',
  keep_weapon_entry: 'Nv.{level} {name}',
  keep_sell_received: '+{amount}G',
  keep_no_slot: 'Expanda os espaços!',

  // === Forja (Sprint 2) ===
  tab_forge: 'Forja',
  forge_title: 'Forja',
  forge_tab_weapon: 'Armas',
  forge_tab_scroll: 'Pergaminhos',
  forge_tab_upgrade: 'Aprimorar Mat.',
  forge_craft_btn: 'Criar',
  forge_craft_success: '{name} criado!',
  forge_not_enough_mat: 'Materiais insuficientes',
  forge_weapon_to_equip: 'Equipar agora?',
  forge_weapon_to_keep: 'Guardar',
  forge_weapon_equip: 'Equipar',
  forge_keep_full_equip: 'Armazenamento cheio — equipando diretamente.',
  forge_cost_label: 'Custo:',
  forge_result_label: 'Resultado:',

  forge_recipe_weapon_lv5: 'Criar Arma Nv.5',
  forge_recipe_weapon_lv10: 'Criar Arma Nv.10',
  forge_recipe_weapon_lv15: 'Criar Arma Nv.15',
  forge_recipe_weapon_lv21: 'Criar Arma Nv.21 (Garantia)',
  forge_recipe_weapon_lv21_desc: 'Ganhe uma arma Lv.21 na hora — sem aprimorar, sem falhas!',
  forge_recipe_scroll_basic: 'Criar Pergaminho Básico',
  forge_recipe_scroll_mid: 'Criar Pergaminho Médio',
  forge_recipe_scroll_hi: 'Criar Pergaminho Alto',
  forge_recipe_scroll_ultra: 'Criar Pergaminho Ultra',
  forge_recipe_upgrade_1: 'Pó de Ferro → Núcleo Refinado',
  forge_recipe_upgrade_2: 'Núcleo Refinado → Essência de Lava',
  forge_recipe_upgrade_3: 'Essência de Lava → Cristal do Abismo',

  scroll_effect_basic: 'Evita destruição em falha (Nv.1-9)',
  scroll_effect_mid: 'Evita destruição em falha (Nv.10-19)',
  scroll_effect_hi: 'Evita destruição em falha (Nv.20-24)',
  scroll_effect_ultra: 'Evita destruição em falha (Nv.25-34)',
  scroll_buy_btn: 'Comprar',

  keep_card_equip: 'Equipar',
  keep_card_sell: 'Vender',
  keep_slot_empty: 'Vazio',

  sacrifice_btn: 'Oferecer Arma',
  sacrifice_panel_title: 'Sacrificar Armas',
  sacrifice_panel_desc: 'Oferecer armas Nv.{level} aumenta sucesso +{tierPct}% por unidade',
  sacrifice_empty: 'Sem armas Nv.{level} no armazenamento',
  sacrifice_bonus_label: 'Bônus: +{pct}%',
  sacrifice_cap_label: '({count}/{cap})',
  sacrifice_offer_btn: 'Oferecer',
  sacrifice_ad_slots: 'Ver anúncio: +{pct}% de sucesso',
  sacrifice_ad_exhausted: 'Limite de anúncios atingido',
  sacrifice_ad_granted: '+3 sacrifícios adicionados!',
  sacrifice_added: 'Sacrifício aceito! +{tierPct}% bônus',
  sacrifice_cap_reached: 'Limite de sacrifício atingido',
  sacrifice_reset: 'Bônus de sacrifício resetado',

  infinity_btn: 'Infinito',
  infinity_active: 'GRÁTIS {sec}s',
  infinity_popup_title: 'Modo Infinito',
  infinity_popup_desc: 'Aprimore à vontade por 10s, sem ouro!\nA chance é a mesma — ainda pode quebrar!',
  infinity_popup_confirm: 'Ver Anúncio',
  infinity_popup_close: 'Fechar',
  infinity_cooldown: 'Disponível em {sec}s',
  infinity_daily_exhausted: 'Limite diário atingido',
  infinity_started: 'Modo Infinito ON! Grátis 10s',
  infinity_ended: 'Modo Infinito encerrado',

  buff_item_luck_charm: 'Amuleto da Sorte',
  buff_item_guarantee: 'Ticket de Garantia',
  buff_item_destroy_guard: 'Guarda Anti-Quebra',
  buff_item_use: 'Usar',
  buff_item_active: 'Ativo',
  buff_item_empty: '0',
  buff_luck_charm_activated: 'Amuleto ativo! +5% próxima melhoria',
  buff_guarantee_activated: 'Ticket ativo! Próxima melhoria 100%',
  buff_destroy_guard_activated: 'Guarda ativo! Próxima falha não quebra',
  buff_luck_charm_consumed: 'Amuleto consumido',
  buff_guarantee_consumed: 'Ticket consumido',
  buff_destroy_guard_consumed: 'Guarda consumido — arma salva!',
  buff_item_already_active: 'Já está ativo!',
  buff_item_none: 'Sem {name}',
  buff_popup_count: 'Você tem: {count}',
  buff_popup_use_btn: 'Usar Agora',
  buff_popup_no_stock: 'Você não tem nenhum. Faça na Forja.',
  buff_popup_luck_charm_effect: '+5% de taxa de sucesso na próxima melhoria',
  buff_popup_guarantee_effect: 'Próxima melhoria garantida com 100% de sucesso',
  buff_popup_destroy_guard_effect: 'Se a próxima melhoria falhar, sua arma NÃO quebrará',

  forge_recipe_item_luck_charm: 'Criar Amuleto da Sorte',
  forge_recipe_item_luck_charm_desc: '+5% taxa de sucesso na próxima melhoria',
  forge_recipe_item_guarantee: 'Criar Ticket de Garantia',
  forge_recipe_item_guarantee_desc: 'Próxima melhoria 100% sucesso',
  forge_recipe_item_destroy_guard: 'Criar Guarda Anti-Quebra',
  forge_recipe_item_destroy_guard_desc: 'Arma NÃO quebrará na próxima falha',
  forge_tab_item: 'Itens',
};

export default ptBR;
